import React from "react";
import { LabelSelectionSection } from "./LabelSelectionSection";
import { LabelCreation } from "./LabelCreation";
import { Loading } from "@src/common/components/Loading";
import { Label, LabelEntityType } from "@api/graphql/generated/generated-types";

interface LabelAssignmentFormProps {
  labelsData: Label[] | undefined;
  labelsLoading: boolean;
  labelsError: any;
  selectedLabels: Label[];
  onAssignLabel: (labelId: string) => void;
  onUnassignLabel: (labelId: string) => void;
  isAssigning: boolean;
  isUnassigning: boolean;
  onLabelCreated: (res: any) => void;
  entityType: LabelEntityType;
}

export function LabelAssignmentForm({
  labelsData,
  labelsLoading,
  labelsError,
  selectedLabels,
  onAssignLabel,
  onUnassignLabel,
  isAssigning,
  isUnassigning,
  onLabelCreated,
  entityType,
}: LabelAssignmentFormProps) {
  if (labelsError) {
    return (
      <div className="text-red-500 dark:text-red-400 text-sm">
        Error loading labels. Please try again.
      </div>
    );
  }

  const allLabels = labelsData || [];
  const availableLabels = allLabels.filter(
    (label) => !selectedLabels.some((assigned) => assigned.id === label.id)
  );

  return (
    <Loading loading={labelsLoading}>
      <div className="space-y-3">
        {/* Already assigned labels section */}
        {selectedLabels.length > 0 && (
          <div className="space-y-1">
            <div className="max-h-32 overflow-y-auto space-y-1 border-b border-gray-200 dark:border-gray-700 pb-2">
              <LabelSelectionSection
                labels={selectedLabels}
                selectedLabelIds={selectedLabels.map((label) => label.id)}
                onLabelToggle={onUnassignLabel}
                title="Currently assigned labels:"
                disabled={isUnassigning}
              />
            </div>
          </div>
        )}
        {/* Available labels to assign section */}
        <LabelSelectionSection
          labels={availableLabels}
          selectedLabelIds={[]}
          onLabelToggle={onAssignLabel}
          title="Available labels to assign:"
          emptyMessage="No additional labels available."
          disabled={isAssigning}
          searchable
        />
        <LabelCreation
          onLabelCreated={onLabelCreated}
          entityType={entityType}
        />
      </div>
    </Loading>
  );
}
